const info = 
{
    title: "Father and Son",
    type: "Feature Length Film"
};

export default info;